<div class="ui-g-12 p-0">
  <button class="btn btn-primary btn-calculator btn-border pointer btn-submit mr-1" (click)="openCalculator()">
    <span>Calculate change</span>
    <i class="pl-2 fal fa-coins"></i>
  </button>
</div>
